import React, {Component} from 'react'
import {Query, Mutation} from 'react-apollo'
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap'
import classnames from 'classnames';

import AnnualLeaveList from './AnnualLeaveList'
import Loading from '../Loading'
import ConfirmModal from '../ConfirmModal'
import RejectModal from './AnnualLeaveRejectModal'

import query from '../../../queries/server/my_annual_leave'
import approveAnnualLeaveMutation from '../../../queries/server/mutations/approve_annual_leave'
import cancelAnnualLeaveMutation from '../../../queries/server/mutations/cancel_annual_leave'

class AnnualLeaveListContainer extends Component {

  state = {
    activeTab: 'my_leave',
    showApproveModal: false,
    showRejectModal: false,
    showCancelModal: false,
    selectedLeaveID: null
  }
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
        this.setState({
            activeTab: tab
        });
    }
  }

  toggleApproveModal = () => {
    this.setState({showApproveModal: !this.state.showApproveModal})
  }

  toggleRejectModal = () => {
    this.setState({showRejectModal: !this.state.showRejectModal})
  }

  toggleCancelModal = () => {
    this.setState({showCancelModal: !this.state.showCancelModal})
  }

  resetApprove = () => {
    this.setState({showApproveModal: false, selectedLeaveID: null})
  }

  resetReject = () => {
    this.setState({showRejectModal: false, selectedLeaveID: null})
  }

  resetCancel = () => {
    this.setState({showCancelModal: false, selectedLeaveID: null})
  }

  render() {

    const {toggleApproveModal, resetApprove, toggleRejectModal, resetReject, toggleCancelModal, resetCancel} = this
    const {showApproveModal, selectedLeaveID, showRejectModal, showCancelModal} = this.state
    const {onEdit} = this.props

    return (
      <Mutation 
        mutation={cancelAnnualLeaveMutation}
        update={(cache, {data: {cancelAnnualLeave}}) => {
          const original = cache.readQuery({query})
          let index = original.me.my_staff_annual_leave.findIndex(({id}) => cancelAnnualLeave.id === id)
          let prop = 'my_staff_annual_leave'
          if(index === -1) {
            index = original.me.annual_leave.findIndex(({id}) => cancelAnnualLeave.id === id)
            prop = 'annual_leave'
          }
          console.log('cancel', cancelAnnualLeave)
          console.log('data', {data: {
            me: {
              ...original.me,
              [prop]: [
                ...original.me[prop].slice(0, index),
                cancelAnnualLeave,
                ...original.me[prop].slice(index+1),
              ]
            }
          }})

          cache.writeQuery({
              query,
              data: {
                me: {
                  ...original.me,
                  [prop]: [
                    ...original.me[prop].slice(0, index),
                    cancelAnnualLeave,
                    ...original.me[prop].slice(index+1),
                  ]
                }
              }
          })
        }}
      >
        {(cancelAnnualLeaveFunc, cancelMut) => (
          <Mutation 
            mutation={approveAnnualLeaveMutation}
            update={(cache, {data: {approveRejectAnnualLeave}}) => {
              const original = cache.readQuery({query})
              const index = original.me.my_staff_annual_leave.findIndex(({id}) => approveRejectAnnualLeave.id === id)
              cache.writeQuery({
                  query,
                  data: {
                    me: {
                      ...original.me,
                      my_staff_annual_leave: [
                        ...original.me.my_staff_annual_leave.slice(0, index),
                        approveRejectAnnualLeave,
                        ...original.me.my_staff_annual_leave.slice(index+1),
                      ]
                    }
                  }
              })
            }}
          >
            {(approveAnnualLeaveFunc, approveMut) => {
              return (
                <Query query={query} fetchPolicy="network-only">
                  {({data, loading}) => {
                    if(loading) return <Loading />
            
                    return (
                      <div>
                        <div className="d-flex flex-column pb-3 pl-3 pt-0">
                          <h5>Total: {data.me.current_year_annual_leave_remaining + data.me.current_year_annual_leave_days_used} days</h5>
                          <h5>Used: {data.me.current_year_annual_leave_days_used} days</h5>
                          <h5>Remaining: {data.me.current_year_annual_leave_remaining} days</h5>
                        </div>
                        <Nav tabs>
                          <NavItem>
                              <NavLink
                                  className={classnames({active: this.state.activeTab === 'my_leave'})}
                                  onClick={() => {
                                      this.toggle('my_leave');
                                  }}
                              >
                                  My Leave
                              </NavLink>
                          </NavItem>
                          <NavItem>
                              <NavLink
                                  className={classnames({active: this.state.activeTab === 'staff_leave'})}
                                  onClick={() => {
                                      this.toggle('staff_leave');
                                  }}
                              >
                                  Staff Leave
                              </NavLink>
                          </NavItem>
                        </Nav>
                        
    
                        <TabContent activeTab={this.state.activeTab}>
                          <TabPane tabId="my_leave">
                            <AnnualLeaveList 
                              data={data.me.annual_leave}
                              onCancel={({id}) => {
                                this.setState({selectedLeaveID: id})
                                toggleCancelModal()
                              }}
                              onEdit={onEdit}
                            />
                          </TabPane>
                          <TabPane tabId="staff_leave">
                            <AnnualLeaveList 
                              canApprove
                              onApprove={({id}) => {
                                this.setState({selectedLeaveID: id})
                                toggleApproveModal()
                              }}
                              onReject={({id}) => {
                                this.setState({selectedLeaveID: id})
                                toggleRejectModal()
                              }}
                              onCancel={({id}) => {
                                this.setState({selectedLeaveID: id})
                                toggleCancelModal()
                              }}
                              onEdit={onEdit}
                              data={data.me.my_staff_annual_leave}
                            />
                          </TabPane>
                        </TabContent>
    
                        <ConfirmModal 
                          isOpen={showApproveModal} 
                          toggle={toggleApproveModal}
                          title="Confirm Leave Approval"
                          message="Please confirm your approval of the annual leave request"
                          saving={approveMut.loading}
                          onConfirm={() => {
                            approveAnnualLeaveFunc({variables: {id: selectedLeaveID, approve: true}})
                              .then(res => resetApprove())
                          }}
                        />

                        <ConfirmModal
                          isOpen={showCancelModal}
                          toggle={toggleCancelModal}
                          title="Confirm Cancel Leave"
                          message="Are you sure you want to cancel the annual leave?"
                          saving={cancelMut.loading}
                          onConfirm={() => {
                            cancelAnnualLeaveFunc({variables: {id: selectedLeaveID}})
                              .then(res => resetCancel())
                          }}
                        />
    
                        <RejectModal
                          isOpen={showRejectModal}
                          toggle={toggleRejectModal}
                          title="Confirm Reject Leave"
                          message="Are you sure you want to reject this annual leave request?"
                          saving={approveMut.loading}
                          onConfirm={(reason) => {
                            approveAnnualLeaveFunc({variables: {id: selectedLeaveID, approve: false, reason}})
                              .then(res => resetReject())
                          }}
                        />
                      </div>
                        
                    )
                  }}
                </Query>
              )
            }}
          </Mutation>
        )}
      </Mutation>
    )
  }
  
}

export default AnnualLeaveListContainer